import palette from '../palette';

export default {
    elevation1: {
        backgroundColor: palette.white,
        boxShadow: '0 2px 20px 0 rgba(0,0,0,0.15)',
    },
};
